import { Field } from 'formik'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { PersonalIdentityCodeField } from '../../field'
import ssn from 'finnish-ssn'

interface Props {
  name: string
  label: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
}

export function PersonalIdentityCodeInput(props: Props): JSX.Element {
  const { name, label, placeholder, required, disabled } = props
  const intl = useIntl()

  const validate = useCallback(
    (value: string | null): string | undefined => {
      if (required && (!value || !value.trim())) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }

      if (value && value.length < 10) {
        return intl.formatMessage({ id: 'personalIdentityCodeInput.tooShort', defaultMessage: 'Liian lyhyt Henkilötunnus' })
      }

      if (value && !ssn.validate(value)) {
        return intl.formatMessage({ id: 'personalIdentityCodeInput.invalid', defaultMessage: 'Virheellinen Henkilötunnus' })
      }

      return undefined
    },
    [required, intl]
  )

  return (
    <Field
      component={PersonalIdentityCodeField}
      id={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      validate={validate}
      disabled={disabled}
    />
  )
}
